// eslint-disable-next-line import/no-amd
define([
    '../../../utils/Globals',
    'jquery',
    'underscore',
    '../../app/models/MabinsoModel'
], (Globals, $, _, MabinsoModel) => {
    const ReportJobModel = MabinsoModel.extend({
        urlRoot: Globals.baseUrl + 'reportJobs/job',
        defaults: {
        },
        initialize() {
        },
        save(success) {
            this.set({ start: this.get('start') + ' ' + this.get('time'), baseUrl: Globals.rootUrl });
            return MabinsoModel.prototype.save.call(this, success);
        },
        everySelect: {
            '1o': 'wizzard.plan.form.every.onetime',
            '1m': 'wizzard.plan.form.every.monthly',
            '1w': 'wizzard.plan.form.every.weekly',
            '1d': 'wizzard.plan.form.every.daily'
        }
    });
    return ReportJobModel;
});



// WEBPACK FOOTER //
// ./src/components/report/models/ReportJobModel.js